import React from 'react';
import ResponsiveECharts from './ResponsiveECharts';
import { baseOption, axeCategorie, axeValeur } from './echartsTheme';

// Palette lisible en série : une couleur par modalité comparée.
const COULEURS = ['#5CA015', '#1F3864', '#E8A33D', '#7B1F2B', '#0027D6', '#8E3A94'];

/**
 * Une courbe par modalité (date de semis ou variété), sur les trois horizons.
 *
 * @param series   [{ nom, valeurs: [v2020, v2035, v2050] }]
 * @param horizons libellés des trois horizons
 * @param nomAxeY  titre de l'axe des ordonnées
 */
export default function CourbesHorizonsChart({ series = [], horizons = [], nomAxeY = 'Perte (%)' }) {
  if (series.length === 0) {
    return <p className="tdb-chargement">Aucune donnée à afficher.</p>;
  }

  const option = {
    ...baseOption(),
    grid: { left: 12, right: 24, bottom: 48, top: 56, containLabel: true },
    tooltip: {
      trigger: 'axis',
      textStyle: { fontSize: 14, color: '#000000' },
      valueFormatter: (valeur) => `${Number(valeur).toFixed(1)} %`,
    },
    xAxis: axeCategorie({ data: horizons }),
    yAxis: axeValeur({ nom: nomAxeY, formatteur: (v) => `${v} %` }),
    series: series.map((serie, i) => ({
      name: serie.nom,
      type: 'line',
      smooth: false,
      symbolSize: 9,
      lineStyle: { width: 3, color: COULEURS[i % COULEURS.length] },
      itemStyle: { color: COULEURS[i % COULEURS.length] },
      data: serie.valeurs,
    })),
  };

  return <ResponsiveECharts option={option} style={{ flex: '1 1 auto', minHeight: 400 }} />;
}
